import { connect } from 'react-redux';

import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ChannelTypes } from '../types/ChannelTypes';
import { ContentInfoCardChannel, ContentInfoChannelOwnProps, ContentInfoChannelProps } from './ContentInfoCardChannel';

export const ConnectedRecentsChannel = connect((state: AppState, props: ContentInfoChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  let list: IContentInfo[] = [];
  state.home.recents.items.forEach((contentId: string) => {
    list.push(state.normalizedContentById[contentId]);
  });

  const recentChannelProps: ContentInfoChannelProps = {
    channelType: ChannelTypes.recents,
    title: Messages.home_recentsTitle(),
    seeAllUrl: siteUrls.recentsUrl(),
    seeAllAltText: Messages.home_recents_alt_seeAll(),
    list,
    isFetching: state.home.recents.isFetching,
    numRows: 1,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state),
    showLastAccessedAt: true
  };
  return recentChannelProps;
})(ContentInfoCardChannel);
